import NiceModal from '@ebay/nice-modal-react'
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material'
import { indigo, teal } from '@mui/material/colors'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { BrowserRouter } from 'react-router'
import './i18n.ts'
import ReactQueryClientProvider from './providers/QueryClientProvider'
import { Router } from './Router'

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      semiTransparentWhite: string
      semiTransparentIndigo: string
    }
  }

  interface PaletteOptions {
    custom?: {
      semiTransparentWhite?: string
      semiTransparentIndigo?: string
    }
  }
}

const theme = createTheme({
  typography: {
    fontFamily: 'Noto Sans'
  },
  palette: {
    mode: 'dark',
    primary: {
      main: teal.A400,
      contrastText: 'rgba(0,0,0,0.87)'
    },
    secondary: {
      main: indigo[200]
    },
    background: {
      default: '#171B1E'
    },
    custom: {
      semiTransparentWhite: 'rgba(255, 255, 255, 0.56)',
      semiTransparentIndigo: 'rgba(121, 134, 203, 0.10)'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        // Global dark scrollbar styles
        '*': {
          scrollbarColor: 'rgba(255, 255, 255, 0.3) transparent'
        },
        '*::-webkit-scrollbar': {
          width: '8px',
          height: '8px'
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
          borderRadius: '4px'
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
          borderRadius: '4px',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.4)'
          }
        }
      }
    }
  }
})

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ReactQueryClientProvider>
          <NiceModal.Provider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <CssBaseline />
              <Router />
            </LocalizationProvider>
          </NiceModal.Provider>
        </ReactQueryClientProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
